var _defs, _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHero2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 900,
    viewBox: "0 0 1600 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#111827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1d4ed8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60a5fa"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: "70%",
    cy: "35%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "icons",
    width: 240,
    height: 240,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    stroke: "#ffffff",
    strokeWidth: 4,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 60 v120",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 120 h120",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 190 h55 l18 -40 l18 70 l22 -55 l18 25 h51",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 55,
    r: 28,
    fill: "#ffffff"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#glow)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#icons)",
    opacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 260,
    r: 200,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1320,
    cy: 700,
    r: 260,
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1180,
    cy: 720,
    r: 180,
    fill: "#f97316"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero2);
export default __webpack_public_path__ + "static/media/hero-2.75aada86217a0c1df08316eb5d1179a1.svg";
export { ForwardRef as ReactComponent };